<template>
  <div class="social-wrap" :class="{ 'no-cursor': isBind }" @click="lgoin">
    <div class="logo-wrap">
      <span class="logo funplus"></span>
      <span class="name">Funplus</span>
    </div>
    <div class="account-name" :class="{ 'no-arr': isBind }">
      <template v-if="isBind">{{ isBind }}</template>
      <template v-else>{{ $t('web_unbind') }}</template>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AccountFunplus',
  data () {
    return {}
  },
  computed: {
    ...mapState({
      bindInfo: state => state.bindInfo.funplus_id,
    }),
    isBind () {
      return this.bindInfo.name || this.bindInfo.email || ''
    }
  },
  methods: {
    lgoin () {
      if (this.isBind) return
      const loginType = this.bindInfo.name ? 'email' : 'mobile' // 手机绑定了就用邮箱，反之亦然
      this.$utils.log('pc_account_center', {
        action: 'bind',
        method: this.$ENUM.SOCIAL_MAP.FUNPLUS_ID
      })
      const params = {
        loginType,
        from: 'bind'
      }
      this.$router.push({
        name: 'Login',
        query: params
      })
    }
  }
}
</script>

<style lang='less' scoped >
@import url('@/assets/styles/account.less');
</style>
